import React, { useState } from "react";
import { observer } from 'mobx-react';
import { Grid, Box, Paper, Typography, Button, InputAdornment } from "@mui/material";
import Header from "../shared/header";
import Footer from "../shared/footer";
import { ClipboardText, Personalcard, SearchNormal, Send2, TickCircle } from "iconsax-react";
import { SearchBox, } from "../shared/components/search-box";
import styles from './dashboard.module.scss';

const Dashboard = observer(({ history, context }) => {
    const [value, setValue] = useState('');

    return (
        <>
            <Header page="dashboard"></Header>
            <Grid className='content' container>
                <Box sx={{ width: '100%' }}>
                    <Box className={styles.searchContainer}>
                        <Typography sx={{ mt: 4 }} variant='p' fontWeight={500}>Start finding people and connect with them</Typography>
                        <form onSubmit={() => history.push('/find-people/' + value)}>
                            <SearchBox
                                sx={{ mt: '8px' }}
                                fullWidth
                                placeholder='Search...'
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchNormal
                                                size="32"
                                                variant="Bulk"
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                value={value}
                                onChange={(e) => setValue(e.target.value)}
                                onSubmit={() => history.push('/find-people/' + value)}
                            />
                        </form>
                    </Box>
                    <Box className={styles.guideContainer}>
                        <Paper>
                            <Grid container>
                                <Grid item lg={8}>
                                    <Typography variant='h6' fontWeight={700} color='#242333'>Start Building Your Cards</Typography>
                                    <Typography variant='p' color='#888888'>Start now filling out your data and sharing your information with digital cards</Typography>
                                    <Box sx={{ mt: 7 }}>
                                        <Button color='secondary' className={styles.actionBtn}>
                                            <ClipboardText
                                                size="36"
                                                variant="Bulk"
                                            />
                                            <TickCircle
                                                className={styles.doneIcon}
                                                size="24"
                                                variant="Bold"
                                            />
                                            Add information
                                        </Button>
                                        <Button color='grey' className={styles.actionBtn}>
                                            <Personalcard
                                                size="36"
                                                variant="Bulk"
                                            />
                                            Create card
                                        </Button>
                                        <Button color='grey' className={styles.actionBtn}>
                                            <Send2
                                                size="36"
                                                variant="Bulk"
                                            />
                                            Publish card
                                        </Button>
                                    </Box>
                                </Grid>
                                <Grid item xl={4} display={{ xl: 'block', lg: 'block', md: 'block', sm: 'none', xs: 'none' }} className={styles.cardImage}>

                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>
                </Box>
            </Grid>
            <Footer></Footer>
        </>
    );
});

export default Dashboard;